import React from 'react';
import { NotificationItemContainer } from '../components/NotificationItemContainer';
import { IPlannedInterviewsByFullDate } from 'src/api/base/Interviews/types';
import { QuestionIco } from '../../../../../UserLayout/icons/QuestionIco';
import { getReadableFullDate } from 'src/utils/helpers';

type PNotificationItem = {
  interview: IPlannedInterviewsByFullDate;
  isHighlighted?: boolean;
};

export const NotificationItem: React.FC<PNotificationItem> = (props) => {
  const { interview, isHighlighted = false } = props;

  return (
    <NotificationItemContainer
      NotificationIcon={QuestionIco}
      isHighlighted={isHighlighted}>
      <div style={{ fontSize: '14px' }}>
        <span style={{ fontWeight: 500 }}>
          Your interview with {interview.guest_fullname} is approaching on&nbsp;
        </span>
        <span>
          {getReadableFullDate(interview.date)}
        </span>
      </div>
    </NotificationItemContainer>
  );
};
